import { useMemo } from "react";
import { addDays, format } from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
const sunday = new Date(1970, 1, 1);
function useDaysOfWeek() {
  const { dateFnsOptions, dayLabelFormat } = useCalendarConfiguration();
  const daysOfWeek = useMemo(() => computeDaysOfWeek(dayLabelFormat, dateFnsOptions), [dateFnsOptions, dayLabelFormat]);
  return daysOfWeek;
}
function computeDaysOfWeek(dayLabelFormat, dateFnsOptions) {
  const map = {};
  for (let i = 0; i < 7; i++) {
    map[i] = format(addDays(sunday, i), dayLabelFormat, dateFnsOptions);
  }
  const result = [];
  for (let i = 0; i < 7; i++) {
    result.push(map[(i + dateFnsOptions.weekStartsOn) % 7]);
  }
  return result;
}
export {
  computeDaysOfWeek,
  useDaysOfWeek
};
//# sourceMappingURL=useDaysOfWeek.js.map
